<template>
    <div>
        <!-- Evolução Aplicação -->
        <div class="modal fade" id="aplicEvolModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="receita">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Evolução
                            <span class="badge badge-secondary" v-if="edicao">{{ edicao.id_receita_evolucao ? '#' + edicao.id_receita_evolucao : 'Nova' }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="receita && receita.anamnese && receita.anamnese.atendimento_procedimento && receita.anamnese.atendimento_procedimento.atendimento && receita.anamnese.atendimento_procedimento.atendimento.paciente">
                            <div class="lead">{{ receita.anamnese.atendimento_procedimento.atendimento.paciente.st_nome }}</div>
                            <div>#{{ receita.anamnese.atendimento_procedimento.id_atendimento }}</div>
                            <div v-if="receita.titulo">{{ receita.titulo }}</div>
                        </div>

                        <div v-if="edicao.id_receita_evolucao" class="alert alert-secondary text-muted">
                            <span v-if="edicao.usuario">
                                {{ edicao.usuario.st_login }}, em {{ $util.getFormatDate(edicao.created_at) }} {{ edicao.created_at.slice(11,16) }}
                                <span v-if="edicao.created_at != edicao.updated_at"> - Atualizado em {{ $util.getFormatDate(edicao.updated_at) }} {{ edicao.updated_at.slice(11,16) }}</span>
                            </span>
                        </div>
                        
                        <div class="form-row">
                            <div class="col-md-12">
                                <az-input 
                                    required
                                    :validate="validate"
                                    v-model="edicao.st_texto" 
                                    label="Evolução" 
                                    type="textarea" 
                                    rows="5" />
                            </div>
                        </div>

                        <pre v-if="false">{{ receita }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar">{{ !edicao.id_receita_evolucao ? 'Incluir' : 'Atualizar' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            receita: null, 
            edicao: null, 
            validate: false, 
        }
    },

    components: { 
        AzSubmit,
        AzInput, 
    }, 
    
    methods: {
        abrir(receita) {
            this.validate = false; 

            this.edicao = { 
                id_receita: receita.id_receita, 
                fl_ativo: true, 
                st_texto: ""
            };

            this.receita = _.cloneDeep(receita);
            $('#aplicEvolModal').modal('show')
        },

        editar (receita, evolucao) { 
            this.validate = false; 
            this.edicao = _.cloneDeep(evolucao);
            this.receita = _.cloneDeep(receita);
            $('#aplicEvolModal').modal('show');
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'pep',
                func: 'receita_evolucao',
                dados: this.edicao,
                toast: true, 
                callback: () => {
                    $('#aplicEvolModal').modal('hide');
                    this.$emit('refresh', this.receita);
                }
            });
        }
    }
}
</script>
